import { useI18n } from "../i18n";

export default function LanguageSwitcher({ compact = false }) {
    const { lang, setLang } = useI18n();
    const options = [
        { code: "en", flag: "🇬🇧", label: "EN" },
        { code: "sv", flag: "🇸🇪", label: "SV" },
    ];
    return (
        <div
            className="inline-flex items-center gap-0.5 p-0.5 rounded-md border border-[var(--border-base)] bg-[var(--bg-card)]"
            data-testid="language-switcher"
            role="group"
            aria-label="Language"
        >
            {options.map((o) => {
                const active = lang === o.code;
                return (
                    <button
                        key={o.code}
                        type="button"
                        onClick={() => setLang(o.code)}
                        data-testid={`lang-${o.code}`}
                        aria-pressed={active}
                        className={`flex items-center gap-1 px-2 py-1 rounded text-[10px] font-extrabold uppercase tracking-widest transition-colors ${
                            active
                                ? "bg-[var(--accent-hex)] text-[var(--accent-text)]"
                                : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
                        }`}
                    >
                        <span aria-hidden>{o.flag}</span>
                        {!compact && <span>{o.label}</span>}
                    </button>
                );
            })}
        </div>
    );
}
